import { Node } from 'slate'

import { CSRF } from '../utils/CSRF'
import { BaseRepository } from './BaseRepository'

export class AutocompleteAPI extends BaseRepository {
  getAutocomplete(nodes: Node[], category: string, productName: string, productDescription: string, projectUUID: string, clipUUID: string) {
    return super.getHttpClientInstance().post(
      `/projects/${projectUUID}/clips/${clipUUID}/segments/autocomplete`,
      { nodes: nodes, category, productName, productDescription },
      {
        'X-CSRF-Token': CSRF.getToken(),
        'Content-Type': 'application/json',
      },
    )
  }
}
